// frontend/src/hooks/useForecastMutations.js
//
// Bulk write paths for the Forecast resource. The grid is SSRM-driven
// (one row per Item+Location).

import { apiJson } from '../queries/api';
import { DATA } from '../queries/dataChanged';
import { useApiMutation } from '../queries/useApiMutation';

const FORECASTS_API = '/api/forecasts/';


/**
 * Persist edits from the ForecastGrid: existing rows go through
 * `updates` (PATCH-style) and new rows go through `creates`. Returns
 * `{ summary: { succeeded, failed }, errors? }`.
 *
 * Variables: { updates, creates }
 */
export function useForecastBulkUpsert() {
  return useApiMutation({
    mutationFn: ({ updates, creates }) =>
      apiJson.post(`${FORECASTS_API}bulk-upsert/`, { updates, creates }),
    changes: [DATA.forecasts],
  });
}
